"use client";
import React, { useEffect, useState } from "react";
import DesktopHeader from "./desktop/DesktopHeader";
import MobileHeader from "./mobile/MobileHeader";
import { useDispatch, useSelector } from "react-redux";
import { updateLanguage } from "@/lib/store/slice/appSlice";
import { IProductsByCountryCategory } from "@/lib/interface";
import { useQuery } from "react-query";
import { CountryCategory } from "@/lib/http";

const Header = ({ language }: { language: any }) => {
  const dispatch = useDispatch();
  const { countrySlug } = useSelector((state: any) => state.app);
// console.log('countrySlug',countrySlug)
  const [categoryData, setCategoryData] =
    useState<IProductsByCountryCategory | null>(null);

  const { isLoading } = useQuery({
    queryKey: ["get-category", countrySlug],
    queryFn: async () => {
      const res = await CountryCategory.api("get", {
        params: "all",
        postfix: `?CountrySlug=${countrySlug}`,
      });
      if (res?.status === 200) {
        setCategoryData(res.data || null);
      }
    },
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (language) dispatch(updateLanguage(language));
  }, [dispatch, language]);

// console.log('categoryData',categoryData)

  return (
    <>
        <DesktopHeader isLoading={isLoading} categoryData={categoryData} />
        <MobileHeader categoryData={categoryData} />
    </>
  );
};

export default Header;
